/*
* Created on Jan 11, 2021
* @author: Adam Cheng <adamcheng@qnap.com>
*/


export const disableAccountCheckBox = (row_data, currentUser, isOwner, permissions, currentUserRole = null) => {
    const is_self = row_data.id === currentUser.user_id;
    // User Manager cannot operate on Owner users
    if (currentUserRole === 'user_manager' && (row_data.is_owner || row_data.role === 'owner')) return true;
    const has_no_permission = !permissions?.invite_admin && !isOwner;
    const has_permission_and_owner = permissions?.invite_admin && row_data.is_owner;
    const has_permission_unmatch_domain = () => {
        const target_email = row_data.email || row_data.qid;
        const curUser_email = currentUser.emails[0].email;
        if (permissions?.invite_admin) {
            return target_email.split('@')[1].toLowerCase() !== curUser_email.split('@')[1].toLowerCase();
        }
        return false;
    }
    if (isOwner) return false;
    return is_self || has_no_permission || has_permission_and_owner || has_permission_unmatch_domain();
}

export const dataCellLabelToDataGridArea = (name) => {
    if (name && name?.length > 0) {
        return name.replace(/@/g, '').replace(/ /g, '-').toLowerCase();
    }
    return '';
}

export const normalizeSpaceSize = (space_size) => {
    // if (!space_size) return 0;
    let size = parseFloat(space_size);
    let unit = 'B';
    const fixed_digit = 2;
    if (!size || isNaN(size)) {
        size = 0;
        return `${size.toFixed(fixed_digit)}${unit}`;
    }

    if (size > 0 && size < 1024) {
        unit = 'B';
        return `${size.toFixed(fixed_digit)}${unit}`;
    }

    size = size / 1024; // make this to KB
    if (size > 0 && size < 1024) {
        unit = 'KB';
        return `${size.toFixed(fixed_digit)}${unit}`;
    }
    size = size / 1024; // make this to KB
    if (size > 0 && size < 1024) {
        unit = 'MB';
        return `${size.toFixed(fixed_digit)}${unit}`;
    }
    size = size / 1024; // make this to GB
    if (size > 0 && size < 1024) {
        unit = 'GB';
        return `${size.toFixed(fixed_digit)}${unit}`;
    }
    size = size / 1024; // make this to TB
    if (size > 0 && size < 1024) {
        unit = 'TB';
        return `${size.toFixed(fixed_digit)}${unit}`;
    }
    if (size > 1024) {
        unit = 'PB';
        return `${size.toFixed(fixed_digit)}${unit}`;
    }
}

// convert bytes to TeraBytes if smaller than 0.01TB, return 0.01TB
export const bytesToTB = (bytes, unit='TB') => {
    if (!bytes || isNaN(bytes)) return 0;

    if (unit === 'TB') {
        const tb = bytes / (1024 ** 4);
        return tb < 0.01 ? 0.01 : parseFloat(tb.toFixed(2));
    }
    else if (unit === 'GB') {
        const gb = bytes / (1024 ** 3);
        return gb < 0.01 ? 0.01 : parseFloat(gb.toFixed(2));
    }
    else if (unit === 'MB') {
        const mb = bytes / (1024 ** 2);
        return mb < 0.01 ? 0.01 : parseFloat(mb.toFixed(2));
    }
}